"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventManagerImpl = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const events_1 = __importDefault(require("events"));
const Event_1 = __importDefault(require("./Event"));
const prefix = '';
/**
 * Event manager class that wraps an event emitter
 *
 * FIXME: Investigate if this class is really useful? Or can we just use
 * directly the events library (bug #703)
 */
class EventManagerImpl {
    constructor(wrappedEventManager = new events_1.default.EventEmitter()) {
        this._eventManager = wrappedEventManager; // must implement emit, on, once, and removeListener methods
    }
    emitEvent(event, args) {
        this.emit(event, args);
    }
    emit(event, ...args) {
        if (typeof event === 'string') {
            event = new Event_1.default(event);
        }
        this._eventManager.emit(`${prefix}${event.eventName}`, ...args);
    }
    emitProgress(progressName, completeRatio) {
        this._eventManager.emit('progress', { name: progressName, progress: completeRatio });
    }
    once(event, callback) {
        if (typeof event === 'string') {
            event = new Event_1.default(event);
        }
        this._eventManager.once(`${prefix}${event.eventName}`, callback);
    }
    on(event, callback) {
        if (typeof event === 'string') {
            event = new Event_1.default(event);
        }
        this._eventManager.on(`${prefix}${event.eventName}`, callback);
    }
    onEvent(event, callback) {
        this.on(event, callback);
    }
    addListener(event, callback) {
        this.on(event, callback);
    }
    removeListener(event, callback) {
        if (typeof event === 'string') {
            event = new Event_1.default(event);
        }
        this._eventManager.removeListener(`${prefix}${event.eventName}`, callback);
    }
    removeAllListeners(event) {
        if (typeof event === 'string') {
            event = new Event_1.default(event);
        }
        this._eventManager.removeAllListeners(`${prefix}${event.eventName}`);
    }
    off(event, callback) {
        this.removeListener(event, callback);
    }
}
exports.EventManagerImpl = EventManagerImpl;
exports.default = EventManagerImpl;
//# sourceMappingURL=EventManager.js.map